import draftActions from './draft-actions';
import { throttledFetchCategoryAttributeSuggestions } from './attributes-actions';
import { selectCategory } from 'tradera-state/views/syi/selectors/category-selectors';
import {
    setShortDescription,
    resetShortDescription
} from '../reducers/short-description';

export const shortDescriptionActions = {
    setShortDescription: shortDescription => (dispatch, getState) => {
        dispatch(setShortDescription(shortDescription));
        dispatch(draftActions.updateDraftCanBeResumed());
        dispatch(
            throttledFetchCategoryAttributeSuggestions(
                selectCategory(getState()).draftCategoryId,
                shortDescription
            )
        );
    },
    reset: () => dispatch => {
        dispatch(resetShortDescription());
        dispatch(draftActions.updateDraftCanBeResumed());
    }
};
